export const setupConstants = {
  LEVEL_LOAD: "LEVEL_LOAD",
  SUBJECTS_LEVEL_LOAD: "SUBJECTS_LEVEL_LOAD",
  SUBJECTS_LEVEL_DELETE: "SUBJECTS_LEVEL_DELETE",

  LOAD_NEW_PROFILE_PHOTOS: "LOAD_NEW_PROFILE_PHOTOS",
  LOAD_USER_DASHBOARD: "LOAD_USER_DASHBOARD",

  LOAD_KPIS: "LOAD_KPIS",

  GET_COLLECTION: "GET_COLLECTION",

  UPDATE_PARAMETER: "UPDATE_PARAMETER",

  EVALUATIONS_LEVEL_LOAD: "EVALUATIONS_LEVEL_LOAD",
  UPDATE_EVALUATION: "UPDATE_EVALUATION",
  CREATE_EVALUATION: "CREATE_EVALUATION",

  GET_SYS_USERS: "GET_SYS_USERS",
};
